import { combineReducers } from '@reduxjs/toolkit';
import calculator from './calculator/slices/calculator';

export const rootReducer = combineReducers({
  calculator,
});
